import { Alert, Empty, Flex, Form, message, Modal, Row, Select } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setExpenseRequestPagination, setIsLoading, setExpenseYearSummaryChart, setExpenseSummaryChart, setTxnExpenseById, setDropdownWelfareSubTypeByCode, setdropdownProjectByEmployeeId, setEmployeeWelfareDropdown, setCommonTypeByCode, setcreateTxnExpense, setEmployeeInfo } from "../slices/ExpenseSlices";
import * as services from "../Service/expenseApi";
import { dataURLtoFile, generateRandomString } from "utils/helper";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

function toInitialValues(initialValue = {}) {
    return {
        ...initialValue,
        startDate: initialValue?.startDate ? dayjs(initialValue.startDate) : null,
        endDate: initialValue?.endDate ? dayjs(initialValue.endDate) : null,
        totalMinutes: initialValue?.totalMinutes
            ? dayjs()
                .hour(Math.floor(Number(initialValue?.totalMinutes) / 60))
                .minute(Number(initialValue?.totalMinutes) % 60)
            : null,
        welfareTypeId: initialValue?.welfare?.welfareTypeId || null,
        startLocation: initialValue.startLocation || "",
        destination: initialValue.destination || "",
        totalExpense: initialValue.totalExpense || "",
        distanceKm: initialValue.distanceKm || "",
        numberOfDayOfStay: initialValue.numberOfDayOfStay || "",
        netPrice: initialValue.netPrice || "",
        projectId: initialValue?.project?.projectId || initialValue.projectId || null,
        totalNights: initialValue.totalNights || "",
        sendingType: initialValue.sendingType || "",
        companyId: initialValue.companyId || "",
        employeeId: initialValue.employeeId || "",
        description: initialValue.description || "",
        travelBy: initialValue.travelBy?.id || "",
    };

}

const isBase64 = (str) => {
    try {
        atob(str);
        return true;
    } catch {
        return false;
    }
};

const base64ToBytes = (base64) => {
    const binary = atob(base64);

    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }

    return bytes;
};

function toParams(params = {}) {
    const minutes = params?.totalMinutes
        ? params.totalMinutes.hour() * 60 + params.totalMinutes.minute()
        : null;
    return {
        ...params,
        attachFile: params?.attachFile?.map(o => isBase64(o) ? base64ToBytes(o) : o),
        startDate: params?.startDate ? dayjs(params.startDate).format("YYYY-MM-DD") : null,
        endDate: params?.endDate ? dayjs(params.endDate).format("YYYY-MM-DD") : null,
        invoiceDate: params?.endDate ? dayjs(params.endDate).format("YYYY-MM-DD") : null,
        totalMinutes: minutes || null,
        welfareTypeId: params?.welfareTypeId || null,
        startLocation: params.startLocation || "",
        destination: params.destination || "",
        totalExpense: params.totalExpense || "",
        distanceKm: params.distanceKm || "",
        numberOfDayOfStay: params.numberOfDayOfStay || "",
        netPrice: params.netPrice || "",
        projectId: params?.project?.projectId || params.projectId || null,
        totalNights: params.totalNights || "",
        sendingType: params.sendingType || "",
        companyId: params.companyId || "",
        employeeId: params.employeeId || "",
        description: params.description || "",
        travelBy: params?.travelBy?.id || null,
    };
}

const useExpenseMainComponent = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const { currentCompany, currentEmployee } = useSelector((state) => state.company);
    const expenseSummaryChart = useSelector((state) => state.expense.expenseSummaryChart);
    const expenseYearSummaryChart = useSelector((state) => state.expense.expenseYearSummaryChart);
    const expenseRequestPagination = useSelector((state) => state.expense.expenseRequestPagination);
    const txnExpenseById = useSelector((state) => state.expense.txnExpenseById);
    const { dropdownProjectByEmployeeId, dropdownWelfareSubTypeByCode, EmployeeWelfareDropdown, CommonTypeByCode } = useSelector((state) => state.expense);
    const location = useLocation()
    // const [isView, setIsView] = useState(false);
    // const [isEdit, setIsEdit] = useState(false);
    // const [isModalOpen, setModalOpen] = useState(false);
    const [pagination, setPagination] = useState({ page: 0, size: 10 });
    const [isEditExpenseForm, setEditExpenseForm] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isExpenseModalOpen, setIsExpenseModalOpen] = useState(false);
    const [search, setSearch] = useState({});
    const [form] = Form.useForm();
    const [currentExpenseWorkflow, setCurrentExpenseWorkflow] = useState([]);
    const [selectedYear, setSelectedYear] = useState(dayjs().year());
    const [selectedMonth, setSelectedMonth] = useState(dayjs().month() + 1);

    const [previousFile, setpreviousFilew] = useState(null);
    const [files, setFiles] = useState([]);

    const onDeleteFile = () => {
        setpreviousFilew(null);
    }

    const initialValues = useMemo(() => {
        return txnExpenseById ? toInitialValues(txnExpenseById) : toInitialValues({});
    }, [txnExpenseById]);

    const modifiedWelfare = useMemo(() => {
        const modifiedOptions = dropdownWelfareSubTypeByCode?.map((opt) => ({
            value: opt?.id,
            label: i18n.language === "en" ? opt?.nameEn : opt?.name,
            code: opt?.code
        }));
        return modifiedOptions;
    }, [dropdownWelfareSubTypeByCode, i18n.language]);

    const modifiedWelfareType = useMemo(() => {
        const modifiedOptions = EmployeeWelfareDropdown?.map((opt) => ({
            ...opt,
            value: opt?.id,
            label: i18n.language === "en" ? opt?.welfareNameEn : opt?.welfareName,
            code: opt.subcategoryDetails?.code,
            remainingRequest: opt?.remainingRequest,
            remainingCredit: opt?.remainingCredit,
            attachmentFlag: opt?.attachmentFlag,
        }));
        return modifiedOptions;
    }, [EmployeeWelfareDropdown, i18n.language]);

    const modifiedCommonTypeByCode = useMemo(() => {
        const modifiedOptions = CommonTypeByCode?.map((opt) => ({
            value: opt?.id,
            label: i18n.language === "en" ? opt?.nameEn : opt?.name,
            // code: opt?.code
        }));
        return modifiedOptions;
    }, [CommonTypeByCode, i18n.language]);

    const getTxnExpenseById = useCallback(
        async (id) => {
            if (!currentCompany || !currentEmployee) return null;
            dispatch(setIsLoading(true));
            try {
                const response = await services.getMyTxnExpenseById({
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    txnExpenseId: id,
                });
                const data = response?.data?.content || {};
                dispatch(setTxnExpenseById(data));
                return data;
            } catch (error) {
                message.error(error.message || "เกิดข้อผิดพลาดในการดึงข้อมูล");
                return null;
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee, dispatch]
    );

    const updateMyTxnExpense = useCallback(
        async (values, record) => {
            if (!currentCompany || !currentEmployee) return;
            dispatch(setIsLoading(true));
            try {
                await services.updateTxnExpense(
                    toParams({
                        ...values,
                        companyId: currentCompany,
                        employeeId: currentEmployee,
                        txnExpenseRequestId: record?.id,
                        sendingType: "SUBMIT",
                        projectId: values?.projectId
                    })
                );
                message.success(t("common.success"));
                await getExpenseRequestPagination({ page: 0, size: 10 })
                setIsExpenseModalOpen(false);
                setEditExpenseForm(false);
                form.resetFields();
            } catch (error) {
                Modal.error({
                    content: error?.response?.data?.content?.details?.[0]?.value,
                    okText: t("message.ok"),
                });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee, setEditExpenseForm, pagination]
    );

    const updateMyTxnExpenseDraft = useCallback(
        async (form, record) => {
            const values = form.getFieldsValue();
            dispatch(setIsLoading(true));

            try {
                await services.updateTxnExpense(
                    toParams({
                        ...values,
                        companyId: currentCompany,
                        employeeId: currentEmployee,
                        txnExpenseRequestId: record?.id,
                        sendingType: "DRAFT",
                        projectId: values?.projectId,
                        totalExpense: values?.totalExpense,
                        startDate: dayjs(values?.startDate).format("YYYY-MM-DD"),
                        endDate: dayjs(values?.endDate).format("YYYY-MM-DD"),
                    })

                );
                message.success("บันทึกสำเร็จ");
                await getExpenseRequestPagination({ page: 0, size: 10 })
                setEditExpenseForm(false);
                setIsExpenseModalOpen(false);
                form.resetFields();
            } catch (error) {
                Modal.error({
                    content: error?.response?.data?.content?.details?.[0]?.value,
                    okText: t("message.ok"),
                });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee, dispatch]
    );

    const createTxnExpense = useCallback(
        async (values) => {
            let response;

            try {
                dispatch(setIsLoading(true));

                const minutes = values?.totalMinutes
                    ? values?.totalMinutes?.hour() * 60 + values?.totalMinutes?.minute()
                    : null;

                const response = await services.createTxnExpense({
                    ...values,
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    sendingType: "SUBMIT",
                    projectId: values?.projectId,
                    startDate: values?.startDate ? dayjs(values.startDate).format("YYYY-MM-DD") : null,
                    endDate: values?.endDate ? dayjs(values.endDate).format("YYYY-MM-DD") : null,
                    invoiceDate: values?.endDate ? dayjs(values.endDate).format("YYYY-MM-DD") : null,
                    totalMinutes: minutes
                });

                message.success(t("common.successsfull"));
                dispatch(setcreateTxnExpense({}));
                setIsExpenseModalOpen(false);
                form.resetFields();
                getExpenseRequestPagination({ page: 0, size: 10 });

            } catch (error) {
                Modal.error({
                    content: response?.data?.content?.details?.[0]?.value
                        || error?.response?.data?.content?.details?.[0]?.value
                        || error.message,
                    okText: t("message.ok"),
                });
                setIsExpenseModalOpen(false);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee]
    );

    const createTxnExpenseDraft = useCallback(
        async (form) => {
            const values = form.getFieldsValue(true);
            let response;

            try {
                dispatch(setIsLoading(true));
                const minutes = values?.totalMinutes
                    ? values?.totalMinutes?.hour() * 60 + values?.totalMinutes?.minute()
                    : null;

                const response = await services.createTxnExpense(
                    {
                        ...values,
                        companyId: currentCompany,
                        employeeId: currentEmployee,
                        sendingType: "DRAFT",
                        projectId: values?.projectId,
                        startDate: dayjs(values?.startDate).format("YYYY-MM-DD"),
                        endDate: dayjs(values?.endDate).format("YYYY-MM-DD"),
                        invoiceDate: dayjs(values?.endDate).format("YYYY-MM-DD"),
                        totalMinutes: minutes
                    }
                );

                setIsExpenseModalOpen(false);
                form.resetFields();
                getExpenseRequestPagination({ page: 0, size: 10 })

            } catch (error) {
                Modal.error({
                    content: response?.data?.content?.details?.[0]?.value
                        || error?.response?.data?.content?.details?.[0]?.value
                        || error.message,
                    okText: t("message.ok"),
                });
                setIsExpenseModalOpen(false);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee, pagination]
    );

    const onView = useCallback(
        async (record) => {
            // setIsView(true);
            // setIsEdit(false);
            const data = await getTxnExpenseById(record.id);
            if (data) setEditExpenseForm(true);
        },
        [getTxnExpenseById]
    );

    const onEdit = useCallback(
        async (record) => {
            // setIsEdit(true);
            // setIsView(false);
            const data = await getTxnExpenseById(record.id);
            if (data) setEditExpenseForm(true);
        },
        [getTxnExpenseById]
    );

    const onSubmit = useCallback(
        (values, record) => {
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: <p>{t("generaInfo.are-you-sure-confirm-to-edit")}</p>,
                onOk: async () => {
                    await updateMyTxnExpense(values, record);
                },
                okText: t("common.confirm"),
                cancelText: t("common.cancel"),
            });
        },
        [updateMyTxnExpense, t]
    );

    const onSubmitCreate = useCallback((values) => {
        Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: <p>{t("generaInfo.are-you-sure-confirm-to-create")}</p>,
            onOk: async () => {
                await createTxnExpense(values);
            },
            okText: t("common.confirm"),
            cancelText: t("common.cancel"),
        });
    }, [createTxnExpense, t]);

    const onSubmitCreateDraft = useCallback((values) => {
        Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: <p>{t("generaInfo.are-you-sure-confirm-to-create-draft")}</p>,
            onOk: async () => {
                await createTxnExpenseDraft(values);
            },
            okText: t("common.confirm"),
            cancelText: t("common.cancel"),
        });
    }, [createTxnExpenseDraft, t]);

    const rejectExpenseRequest = useCallback(async (params) => {
        try {
            dispatch(setIsLoading(true))
            const values = {
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                requestId: params?.id
            }
            if (location.pathname.match("^\/employee\/.*.\/document$")) {
                const response = await services.rejectFlowForHr(values);
            } else if (location.pathname.match("^\/expense")) {
                const response = await services.rejectExpenseRequestForCustomer(values)
            }
            getExpenseRequestPagination({ page: 0, size: 10 })
        } catch (error) {
            console.error("error ", error);
        } finally {
            dispatch(setIsLoading(false))
            setIsExpenseModalOpen(false)
        }
    }, [currentCompany, currentEmployee])

    const onRejectExpense = useCallback((values) => {

        Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: <p>{t("generaInfo.are-you-sure-confirm-to-create-draft")}</p>,
            onOk: async () => {
                await rejectExpenseRequest(values);
            },
            okText: t("common.confirm"),
            cancelText: t("common.cancel"),
        });
    }, [rejectExpenseRequest, t]);

    const getExpenseYearSummaryChart = useCallback(async (year) => {
        if (!currentCompany || !currentEmployee) return;
        dispatch(setIsLoading(true));
        try {
            const response = await services.getMyExpenseYearSummaryChart({
                companyId: currentCompany,
                employeeId: currentEmployee,
                year: year
            });
            dispatch(setExpenseYearSummaryChart(response.data?.content || []));
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentEmployee, dispatch]);

    const getExpenseSummaryChart = useCallback(async (year, month) => {
        if (!currentCompany || !currentEmployee) return;
        dispatch(setIsLoading(true));
        try {
            const response = await services.getMyExpenseSummaryChart({
                companyId: currentCompany,
                employeeId: currentEmployee,
                year: year,
                month: month
            });
            dispatch(setExpenseSummaryChart(response.data?.content || []));
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentEmployee, dispatch]);

    const getExpenseRequestPagination = useCallback(
        async (params = {}) => {
            if (!currentCompany || !currentEmployee) return;
            dispatch(setIsLoading(true));
            try {
                const response = await services.getMyExpenseRequestPagination({
                    ...params,
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                });
                dispatch(setExpenseRequestPagination(response.data?.page?.content || []));
                setPagination({
                    ...params?.pagination,
                    current: response?.data?.page?.number + 1,
                    pageNo: response?.data?.page?.number + 1,
                    page: response?.data?.page?.number + 1,
                    total: response.data?.page?.totalElements,
                    size: response?.data?.page?.totalPages
                });
            } catch (error) {
                console.error(error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee, dispatch, pagination]
    );
    const onPageChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];

            const modifiedParams = toParams({
                // pagination: {
                page: tablePagination?.current - 1,
                size: tablePagination?.pageSize,
                pageSize: tablePagination?.pageSize,
                current: tablePagination.current - 1,
                // },
                sortBy: modifiedSorter,
            });
            getExpenseRequestPagination(modifiedParams);
        },
        [getExpenseRequestPagination]
    );


    const getDropdownWelfareSubTypeByCode = useCallback(async () => {
        if (!currentCompany || !currentEmployee) return;
        dispatch(setIsLoading(true));
        try {
            const response = await services.getDropdownWelfareSubTypeByCode({
                companyId: currentCompany,
                employeeId: currentEmployee,
                code: "WELFARE_SUBCATEGORY",
            });
            dispatch(setDropdownWelfareSubTypeByCode(response.data?.content || []));
        } catch (error) {
            message.error(error.message || "เกิดข้อผิดพลาดในการโหลดประเภทค่าใช้จ่าย");
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentEmployee, dispatch]);

    const getEmployeeWelfareDropdown = useCallback(async () => {
        if (!currentCompany || !currentEmployee) return;
        dispatch(setIsLoading(true));
        try {
            const response = await services.getEmployeeWelfareDropdown({
                companyId: currentCompany,
                employeeId: currentEmployee,

            });
            dispatch(setEmployeeWelfareDropdown(response.data?.content || []));
        } catch (error) {
            message.error(error.message || "เกิดข้อผิดพลาดในการโหลดประเภทค่าใช้จ่าย");
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentEmployee, dispatch]);

    const getdropdownProjectByEmployeeId = useCallback(async () => {
        if (!currentCompany || !currentEmployee) return;
        dispatch(setIsLoading(true));
        try {
            const response = await services.dropdownProjectByEmployeeId({
                companyId: currentCompany,
                employeeId: currentEmployee,
            });
            dispatch(setdropdownProjectByEmployeeId(response.data?.content || []));
        } catch (error) {
            message.error(error.message || "เกิดข้อผิดพลาดในการโหลดโปรเจค");
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentEmployee, dispatch]);

    const getCommonTypeByCode = useCallback(async () => {
        if (!currentCompany || !currentEmployee) return;
        dispatch(setIsLoading(true));
        try {
            const response = await services.getCommonTypeByCode({
                companyId: currentCompany,
                employeeId: currentEmployee,
                groupType: "TRANSPORT",
            });
            dispatch(setCommonTypeByCode(response.data || []));

        } catch (error) {
            message.error(error.message || "เกิดข้อผิดพลาดในการโหลดโปรเจค");
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentEmployee, dispatch,]);

    const getExpenseWorkflow = useCallback(async () => {
        let data = [];
        if (txnExpenseById?.approveStatusEn !== 'Draft') {
            data = await services.getWorkflowByRequestId({
                requestId: generateRandomString(),
                companyId: currentCompany,
                employeeId: currentEmployee,
                flowRequestId: txnExpenseById?.id,
            });
            setCurrentExpenseWorkflow(data?.data?.approvalSequence)
        }
    }, [currentCompany, currentEmployee, txnExpenseById?.approveStatusEn, txnExpenseById?.id])

    const handleYearChange = useCallback((year) => {
        setSelectedYear(year);
        getExpenseYearSummaryChart(year);
        getExpenseSummaryChart(year, selectedMonth);
    }, [getExpenseYearSummaryChart, getExpenseSummaryChart, selectedMonth]);

    const handleMonthChange = useCallback((month) => {
        setSelectedMonth(month);
        getExpenseSummaryChart(selectedYear, month);
    }, [getExpenseSummaryChart, selectedYear]);

    useEffect(() => {
        if (currentCompany) {
            getExpenseYearSummaryChart(selectedYear);
            getExpenseSummaryChart(selectedYear, selectedMonth);
            getExpenseRequestPagination({ page: 0, size: 10 });
        }
    }, [currentCompany, currentEmployee]);

    useEffect(() => {
        if (currentCompany) {
            getDropdownWelfareSubTypeByCode();
        }
    }, [currentCompany, getDropdownWelfareSubTypeByCode])

    useEffect(() => {
        if (isExpenseModalOpen && currentCompany) {
            getdropdownProjectByEmployeeId();
            getEmployeeWelfareDropdown();
            getCommonTypeByCode();
            getExpenseWorkflow();

            if (txnExpenseById?.id && txnExpenseById?.approveStatusEn !== 'Draft') {
                getExpenseWorkflow();
            }
        }
    }, [isExpenseModalOpen, currentCompany, currentEmployee, txnExpenseById?.id, txnExpenseById?.approveStatusEn]);

    const MonthlyExpenseChart = () => {
        const monthlist = [
            { month: "ม.ค.", monthEn: "Jan" },
            { month: "ก.พ.", monthEn: "Feb" },
            { month: "มี.ค.", monthEn: "Mar" },
            { month: "เม.ย.", monthEn: "Apr" },
            { month: "พ.ค.", monthEn: "May" },
            { month: "มิ.ย.", monthEn: "Jun" },
            { month: "ก.ค.", monthEn: "Jul" },
            { month: "ส.ค.", monthEn: "Aug" },
            { month: "ก.ย.", monthEn: "Sep" },
            { month: "ต.ค.", monthEn: "Oct" },
            { month: "พ.ย.", monthEn: "Nov" },
            { month: "ธ.ค.", monthEn: "Dec" },
        ];

        const currentYear = dayjs().year();
        const yearOptions = Array.from({ length: 3 }, (_, i) => {
            const year = currentYear - 1 + i;
            return {
                value: year,
                label: i18n.language === "en" ? `${year}` : `${year + 543}`
            };
        });

        const options = {
            chart: {
                type: "line",
                toolbar: { show: false },
                zoom: { enabled: false }
            },
            stroke: {
                curve: "smooth",
                width: 3
            },
            markers: {
                size: 5,
                hover: {
                    size: 7
                }
            },
            dataLabels: { enabled: false },
            colors: ["var(--button-color)"],
            xaxis: {
                categories: expenseYearSummaryChart.map((o) => {
                    const monthObj = monthlist[o.month - 1];
                    return i18n.language === "en" ? monthObj.monthEn : monthObj.month;
                }),
                labels: {
                    style: {
                        fontSize: "13px",
                        fontFamily: "NotoSansThai"
                    }
                },
            },
            yaxis: {
                min: 0,
                labels: {
                    formatter: (val) => (val >= 1000 ? val / 1000 + "k" : val)
                }
            },
            grid: {
                borderColor: "#f0f0f0",
                strokeDashArray: 4
            },
            title: {
                text: undefined,
            },
            tooltip: {
                y: {
                    formatter: (val) => val.toLocaleString() + t("unit.baht")
                }
            },
        };

        const series = [{ name: t("dashboard.label.amount"), data: expenseYearSummaryChart.map((o) => o.totalExpense) }];

        return (
            <div>
                <Flex gap={16} align="center">
                    <span style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        fontFamily: "NotoSansThai",
                        color: "#263238"
                    }}>
                        {t("expense.monthly_expense")}
                    </span>
                    <Select
                        value={selectedYear}
                        onChange={handleYearChange}
                        options={yearOptions}
                        style={{ width: 80 }}
                    />
                </Flex>
                <Chart options={options} series={series} type="line" height={380} />
            </div>
        );
    };

    const ExpenseDonutChart = () => {
        const monthlist = [
            { month: "ม.ค.", monthEn: "Jan", value: 1 },
            { month: "ก.พ.", monthEn: "Feb", value: 2 },
            { month: "มี.ค.", monthEn: "Mar", value: 3 },
            { month: "เม.ย.", monthEn: "Apr", value: 4 },
            { month: "พ.ค.", monthEn: "May", value: 5 },
            { month: "มิ.ย.", monthEn: "Jun", value: 6 },
            { month: "ก.ค.", monthEn: "Jul", value: 7 },
            { month: "ส.ค.", monthEn: "Aug", value: 8 },
            { month: "ก.ย.", monthEn: "Sep", value: 9 },
            { month: "ต.ค.", monthEn: "Oct", value: 10 },
            { month: "พ.ย.", monthEn: "Nov", value: 11 },
            { month: "ธ.ค.", monthEn: "Dec", value: 12 },
        ];

        const monthOptions = monthlist?.map((m) => ({
            value: m?.value,
            label: i18n.language === "en" ? m?.monthEn : m?.month
        }));

        const chartData = expenseSummaryChart?.chartData ?? [];
        const countData = expenseSummaryChart?.countBySubcategory ?? [];
        const countMap = countData.reduce((acc, item) => {
            acc[item.subcategoryCode] = item.count;
            return acc;
        }, {});

        const labels = chartData.map((item) =>
            i18n.language === "en" ? item.subcategoryNameEn || item.subcategoryName : item.subcategoryName
        );
        const series = chartData.map((item) => item.totalExpense);
        const total = series.reduce((sum, val) => sum + val, 0);

        const labelsWithCount = chartData.map((item, index) => {
            const label =
                i18n.language === "en"
                    ? item.subcategoryNameEn || item.subcategoryName
                    : item.subcategoryName;

            const count = countMap[item.subcategoryCode] ?? 0;
            const total = item.totalExpense ?? 0;
            const colors = ["#4CA6F0", "#FF92AE", "#F9C74F", "#FA8072", "#6A4C93", "#43AA8B", "#F3722C", "#277DA1", "#90BE6D", "#E63946",];
            const Color = colors[index % 10];

            return (
                <div key={item.subcategoryCode} style={{ textAlign: "center", marginTop: 12 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <span
                            style={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: Color,
                                display: "inline-block",
                                marginRight: 6,
                            }}
                        ></span>
                        <span style={{ fontWeight: "bold", color: "#263238", fontSize: 18 }}>
                            {total.toLocaleString()}
                        </span>
                    </div>
                    <span style={{ color: "#718096", fontSize: 14 }}>{label}</span>
                </div>
            );
        });

        const options = {
            chart: { type: "donut" },
            labels,
            colors: ["#4CA6F0", "#FF92AE", "#F9C74F", "#FA8072", "#6A4C93", "#43AA8B", "#F3722C", "#277DA1", "#90BE6D", "#E63946",],
            legend: { show: false },
            dataLabels: { enabled: false },
            tooltip: { y: { formatter: (val) => val.toLocaleString() + ` ${t("unit.baht")}` } },
            plotOptions: {
                pie: {
                    donut: {
                        size: "75%",
                        labels: {
                            show: true,
                            total: { show: true, label: "", formatter: () => total.toLocaleString() },
                        },
                    },
                },
            },
        };

        return (
            <div>
                <Flex gap={16} align="center" justify="center">
                    <h3 style={{ color: "#263238" }}>{t("expense.expense_summary_for")}</h3>
                    <Select
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        options={monthOptions}
                        style={{ width: 80 }}
                    />
                </Flex>
                {expenseSummaryChart?.chartData?.length !== 0
                    ? (
                        <Chart options={options} series={series} type="donut" height={350} />)
                    : (
                        <Flex
                            justify="center"
                            align="center"
                            style={{ minHeight: 350 }}
                        >
                            <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={
                                    <span>
                                        {t("common.no_data")}
                                    </span>
                                } />
                        </Flex>
                    )}
                <Row justify="center" style={{ gap: "20px", marginTop: "12px" }}>
                    {labelsWithCount}
                </Row>
            </div>
        );
    };


    const handleSearchFilter = (values) => {
        try {
            const filters = {
                ...values,
            };
            setSearch(filters);
            getExpenseRequestPagination({
                page: 0,
                size: 10,
                ...filters
            });
        } catch (error) { }
    };

    const getEmployee = useCallback(
        async ({ employeeId, visible = false, edit = false }) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getGeneralInfomation({
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    visible: visible,
                    employeeId,
                    isEdit: edit
                });
                dispatch(setEmployeeInfo(response.data || {}));
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch]
    );

    useEffect(() => {
        if (isExpenseModalOpen) {
            getEmployee({ employeeId: currentEmployee, visible: false, edit: false });
        }
    }, [currentEmployee, getEmployee, isExpenseModalOpen])

    const onAttachFileChange = async ({
        attachFile,
        setFieldValue,
        setImageUrl,
        seeFileName,
        initialValuesImageUrl,
        initialValuesFileName,
        initialValuesFileType,
        initialValuesFileList,
        setInitialValuesFileName,
        setInitialValuesFileType,
        setInitialValuesImageUrl,
        setInitialValuesFileList,
        setFileType
    }) => {
        const fileUrls = [...initialValuesImageUrl];
        const fileNames = [...initialValuesFileName];
        const fileList = [...initialValuesFileList];
        const fileTypes = [...initialValuesFileType];
        const attachFileList = attachFile?.file;

        try {
            const allowedTypes = ["image/png", "image/jpeg", "application/pdf", "application/vnd.ms-excel"];
            const fileType = attachFileList?.type;
            const fileSize = attachFileList?.size;
            fileTypes.push(fileType)
            if (!allowedTypes.includes(fileType)) {
                Modal.error({
                    title: "File Upload Error",
                    content: "Unsupported file type. Only PNG, JPEG, XLS, and PDF are allowed.",
                    okText: "Close",
                    okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
                });
                // setIsProcessing(false);
                return;
            }

            if (fileType === "application/pdf" || fileType === "application/vnd.ms-excel") {
                const base64 = await new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(attachFileList?.originFileObj);
                    reader.onload = () => resolve(reader.result);
                });

                const filename = `${Date.now()}_${attachFileList?.name}`;
                const file = dataURLtoFile(base64, filename);
                fileUrls.push(base64)
                fileNames.push(filename)
                fileList.push(file)
            } else {
                const compressImg = await services.compressedImage({
                    file: attachFileList?.originFileObj,
                });

                const base64 = await new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(compressImg.data);
                    reader.onload = () => resolve(reader.result);
                });

                const filename = `${Date.now()}_${attachFileList?.name}`;
                const file = dataURLtoFile(base64, filename);

                fileUrls.push(base64)
                fileNames.push(filename)
                fileList.push(file)
            }
        } catch (error) {
            Modal.error({
                title: "File Upload Error",
                content: error.message,
                okText: "Close",
                okButtonProps: { style: { height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" } },
            });
            // setIsProcessing(false);
            return;
        }
        // }

        setpreviousFilew(attachFileList);
        setFiles(fileList);
        seeFileName(fileNames);
        setInitialValuesFileName(fileNames);
        setInitialValuesFileType(fileTypes);
        setInitialValuesImageUrl(fileUrls);
        setInitialValuesFileList(fileList);
        setFieldValue("attachFile", fileList);
        setFieldValue("attachFileType", fileTypes);
        setFieldValue("attachFileName", fileNames);
        setImageUrl(fileUrls);
        setFileType(fileTypes)
    };

    return {
        MonthlyExpenseChart,
        ExpenseDonutChart,
        expenseYearSummaryChart,
        getTxnExpenseById,
        onView,
        onEdit,
        onSubmit,
        updateMyTxnExpense,
        updateMyTxnExpenseDraft,
        txnExpenseById,
        initialValues,
        expenseRequestPagination,
        dropdownWelfareSubTypeByCode: modifiedWelfare,
        getDropdownWelfareSubTypeByCode,
        getdropdownProjectByEmployeeId,
        dropdownProjectByEmployeeId,
        isEditExpenseForm,
        setEditExpenseForm,
        createTxnExpense,
        createTxnExpenseDraft,
        getEmployeeWelfareDropdown,
        getCommonTypeByCode,
        EmployeeWelfareDropdown: modifiedWelfareType,
        CommonTypeByCode: modifiedCommonTypeByCode,
        isModalOpen,
        setIsModalOpen,
        pagination,
        onPageChange,
        isExpenseModalOpen,
        setIsExpenseModalOpen,
        handleSearchFilter,
        form,
        currentExpenseWorkflow,
        getEmployee,
        getExpenseWorkflow,
        onSubmitCreate,
        onSubmitCreateDraft,
        onAttachFileChange,
        onDeleteFile,
        onRejectExpense
    };
};

export default useExpenseMainComponent;
